import React from "react";
import { Image } from "react-bootstrap";

/**
 * Componente para manejar URLs de imágenes normalizadas a S3
 * Convierte nombres de archivo locales a URLs completas de S3
 *
 * @param {string} src - URL de la imagen o nombre del archivo
 * @param {string} folder - Carpeta en S3 (default: 'logo')
 * @param {string} bucket - Nombre del bucket S3 (default: 'trippin-hoteles')
 * @param {string} region - Región de AWS (default: 'us-east-2')
 * @param {string} fallback - Imagen por defecto si hay error
 * @param {object} props - Props adicionales para el componente Image
 */
const S3Image = ({
  src,
  folder = "logo",
  bucket = process.env.REACT_APP_AWS_S3_BUCKET || "trippin-hoteles",
  region = process.env.REACT_APP_AWS_S3_REGION || "us-east-2",
  fallback = "/not-available.png",
  alt = "Imagen",
  ...props
}) => {
  const getImageUrl = (source) => {
    if (!source) return fallback;

    // Si ya es una URL completa de S3, retornarla tal cual
    if (source.includes("s3.amazonaws.com") || source.includes("s3.")) {
      return source;
    }

    // Si ya es una URL HTTP/HTTPS completa (pero no S3), retornarla
    if (source.startsWith("http://") || source.startsWith("https://")) {
      return source;
    }

    // Si el source ya incluye el prefijo (ej: logo/filename.png), usarlo directamente
    if (source.includes("/")) {
      return `https://${bucket}.s3.${region}.amazonaws.com/${source}`;
    }

    // Si no tiene prefijo, agregar el folder
    const url = `https://${bucket}.s3.${region}.amazonaws.com/${folder}/${source}`;
    return url;
  };

  const handleError = (e) => {
    e.target.src = fallback;
  };

  return (
    <Image src={getImageUrl(src)} alt={alt} onError={handleError} {...props} />
  );
};

export default S3Image;
